import { Component, Input } from '@angular/core';
import { NbDialogRef, NbGlobalPhysicalPosition, NbIconConfig, NbToastrService } from '@nebular/theme';
import { ConfirmModalComponent } from '../modals/confirm-modal.component';

import { LanguageService, MissionService, ObjectService } from '../../_services/index';

import { trigger, transition, animate, style } from '@angular/animations';
import { NbDialogService } from '@nebular/theme';

import  { diffChars }  from '../template-update/character';
import {  take } from 'rxjs/operators';

@Component({
    selector: 'ngx-object-changes-modal',
    templateUrl: 'object-changes-modal.component.html',
    styleUrls: ['object-changes-modal.component.scss'],
    animations: [
        trigger('slideInOut', [
            transition(':enter', [
                style({ opacity: 0 }),
                animate('200ms', style({ opacity: 1 })),
            ]),
            transition(':leave', [
                animate('100ms', style({ opacity: 0 })),
            ])
        ])
    ],
    standalone: false
})
export class ObjectChangesModalComponent {

  positions = NbGlobalPhysicalPosition;
  gameVisibly = [];
  //loadData = false;
  templateObjects;
  templateId = '';
  games;
  //missions = []
  //changeExist = true
  loading = false;
  gamesChanges=[]
  currentLang = '';

  @Input() data;

  constructor(protected ref: NbDialogRef<ObjectChangesModalComponent>,
    public objectService: ObjectService,
    public languageService: LanguageService,
    private toastrService: NbToastrService,
    private dialogService: NbDialogService,
    private missionService: MissionService) {
  }

  ngOnInit(){
    this.checkForChanges(this.data);
  }

  async checkForChanges(data){
    this.loading = true;
    this.templateId = data.templateId;
    this.currentLang = data.currentLang;
    this.games = data.games;
    this.templateObjects = data.templateObjects
    let templateMissions
    this.missionService.listAllMissions().pipe(take(1)).subscribe(allMissions => {
      console.log('found (all) missions:'+allMissions.length);
      //this.missions = missions;

      let start = new Date().getTime();
      console.log('start-list template missions');
      let gamesChanges = [];
      this.missionService.getMissions(`game_templates/${this.templateId}/missions`)
      .pipe(take(1))
      .subscribe(missions => {
        console.log('found template missions:'+missions.length+' - '+((new Date().getTime()-start)/1000)+'sec');
        templateMissions = missions;
        console.log('start-list all games objects');
        console.log('found objects: - '+((new Date().getTime()-start)/1000)+'sec');
        console.log('Assign objects to games');
        for(let game of data.games){
          game.missions = allMissions.filter(mission => game.id == mission.gameId);
        }
        console.log('Check objects');
        for(let i = 0; i < this.templateObjects.length; i++){
          for(let j = 0; j < this.games.length; j++){
            //verification from template to game
            let object
            object = this.games[j].objects.find(object => object.id == this.templateObjects[i].id)
            if(!object){
              //Template object does not exist in the game
              let index
              index = gamesChanges.findIndex(game => game.gameId == this.games[j].id);
              let resultTemplate = this.getMissionSuccessMission(templateMissions, this.templateObjects[i].id, this.templateId)
              if(index >= 0){
                console.log('pushGameChange:object not in game');
                this.pushGameChange(gamesChanges, index, this.templateObjects[i], resultTemplate, null, null)
              }else{
                this.pushNewChange(gamesChanges, this.games[j], this.templateObjects[i], null, resultTemplate, null)
              }
            } else {
              //Template object exist in the game
              let index
              let params = ['labels', 'description', 'pictureLastUpdate', 'externalUrlByLanguage', 'objectPic', 
                'externalUrl', 'isExternalUrlInNewWindow', 'externalUrlLabel', 'filePath']
              for(let k = 0; k < params.length; k++) {
                const param = params[k];
                let isObjectsDiff:boolean
                if(param == 'pictureLastUpdate' || param == 'externalUrl' || param == 'isExternalUrlInNewWindow' 
                    || param == 'filePath'){
                  isObjectsDiff = (object[param] !== this.templateObjects[i][param]);
                }else{
                  if("objectPic"==param){
                    if(this.templateObjects[i][param][this.languageService.currentLang]){
                      if(object[param][this.languageService.currentLang]){
                        isObjectsDiff = object[param][this.languageService.currentLang].url != this.templateObjects[i][param][this.languageService.currentLang].url;
                      } 
                      else isObjectsDiff = true;
                    }
                    else if(object[param][this.languageService.currentLang]){
                      isObjectsDiff = true;
                    }
                    else{
                      isObjectsDiff = false;
                    } 
                  }
                  else{
                    isObjectsDiff = object[param][this.languageService.currentLang] != this.templateObjects[i][param][this.languageService.currentLang];
                  }
                }
                if(isObjectsDiff){
                  
                  //console.log('object diff:'+param);
                  index = gamesChanges.findIndex(change => change.gameId == object.gameId);
                  let resultGame = this.getMissionSuccessMission(this.games[j].missions, object.id, object.gameId)
                  let resultTemplate = this.getMissionSuccessMission(templateMissions, object.id, this.templateId)
                  if(index >= 0){
                    //console.log('pushGameChange:object diff');
                    this.pushGameChange(gamesChanges, index, this.templateObjects[i], resultTemplate, resultGame, object)
                  }else{
                    this.pushNewChange(gamesChanges, this.games[j], this.templateObjects[i], resultGame, resultTemplate, object)
                  }
                  break;
                }
              }
            }
          }  
        }
        //verification from game to template
        for(let game of this.games){
          for(let object of game.objects){
            let objectGameTemplate = this.templateObjects.find(obj=> obj.id == object.id)
            if(!objectGameTemplate){
              let index = gamesChanges.findIndex(gameChange => gameChange.gameId == game.id);
              let result = this.getMissionSuccessMission(game.missions, object.id, game.gameId);
              if(index >= 0){
                //console.log('pushGameChange:game object is not in template');
                this.pushGameChange(gamesChanges, index, null, null, result, object)
              }else {
                this.pushNewChange(gamesChanges, game, null, result, null, object)
              }
            }
          }
        }
        let stop = new Date().getTime();
        console.log('Data treatment took '+((stop-start)/1000)+'sec');
        this.games = this.games;
        this.gamesChanges = gamesChanges;
        this.loading = false;
      });
    });
  }
  getGameById(gameId){
    let game =  this.games.find(game => game.id == gameId);
    return game;
  }

  pushGameChange(gamesChanges, index, templateObjects, resultTemplate, resultGame, object){    
    gamesChanges[index].changes.push({
      templateId: this.templateId,
      template: templateObjects? templateObjects : {labels: {}, description: {}, pictureUrl: ''},
      templateMission: resultTemplate? resultTemplate?.mission : [],
      templateSuccessMission: resultTemplate? resultTemplate?.successMission : [],
      gameMission: resultGame? resultGame?.mission : '',
      gameSuccessMission: resultGame? resultGame.successMission : [],
      objectGame: object? object : {labels: {}, description: {}, pictureUrl: ''},
    })
  }
  pushNewChange(gamesChanges, games, templateObjects, resultGame, resultTemplate, object){
    gamesChanges.push({
      gameId: games.id,
      name: games.name,
      changes:[{
        templateId: this.templateId,
        template: templateObjects? templateObjects : {labels: {}, description: {}, pictureUrl: ''},
        templateMission: resultTemplate? resultTemplate?.mission : [],
        templateSuccessMission: resultTemplate?.successMission,
        gameMission: resultGame? resultGame?.mission : '',
        gameSuccessMission: resultGame? resultGame.successMission : [],
        objectGame: object? object : {labels: {}, description: {}, pictureUrl: ''},
      }]
    })
  }

  deleteObject(object, i, j){
    this.dialogService.open(ConfirmModalComponent, { 
      context: {
        title: 'Confirmation',
        message: `Do you want to delete object '`+object.labels[this.languageService.currentLang]+`'?`
      }, closeOnBackdropClick: false
    })
    .onClose.subscribe(async res => {
      console.log('Dialog returns:'+res);
      if(res){
        console.log('Delete mission');
        await this.objectService.deleteObject(object);
        if(this.gamesChanges[i].changes.length == 1) this.gamesChanges.splice(i, 1)
        else this.gamesChanges[i].changes.splice(j, 1)
      }
    });
  }

  getMissionSuccessMission(missions, objectId ,id){
    let result
    for (let n = 0; n < missions.length; n++) {
      if( missions[n].gameId == id || missions[n].templateId == id) {
        let missionTemplate = missions[n].successObjects.find(successObject => successObject == objectId)
        if(missionTemplate){
          result = {
            successMission : missions[n].successMissions ? missions[n].successMissions[0] : [],
            mission : missions[n].id
          }
          break;
        }
      }
    }
    return result
  }

  close() {
    this.ref.close();
  }

  getDiffAttributes(from, to, param){
    if(from && to){
      let diff = diffChars(from, to , {})
      if( diff.length > 1 ){
        return this.setNewColoredAttribut(diff, param)
      } else return to
    } else if (!from && to){
      return '<span class="added">'+to + '</span>'
    } else return to
  }
  
  ngAfterViewChecked(){
    const added = document.querySelectorAll<HTMLElement>('.added') 
    added.forEach(function(item) {
      item.style.color = '#1dc864',
      item.style.fontSize = '16px';
    });
    const removed = document.querySelectorAll<HTMLElement>('.removed')
    removed.forEach(function(item) {
      item.style.color = 'red';
      item.style.fontSize = '16px';
    }); 
  }

  setNewColoredAttribut(diff, param){
    let att = ''
    for (let i = 0; i < diff.length; i++) {
      const element = diff[i];
      if(!element.removed && !element.added){
        att += element.value 
      }
      if(param === 'to'){
        if(!element.removed && element.added){
          att += '<span class="added">'+ element.value + '</span>'
        }
      }else{
        if(!element.removed && element.added){
          att += '<span class="removed">'+ element.value + '</span>'
        }
      }
    }
    return att
  }
  
  applyChanges(gameId, objectTemplate, objectGame, i, j, n){
    let result
    let error
    if(!objectGame.id) {
      let data:any ={
        collectionPath: `games/${gameId}/objects`,
        //filePath: `games/${gameId}/objects/${objectTemplate.id}.jpg`,
        description       : objectTemplate.description,
        gameId            : gameId,
        id                : objectTemplate.id,
        labels            : objectTemplate.labels,
        objectTypeId      : objectTemplate.objectTypeId,
        pictureLastUpdate : objectTemplate.pictureLastUpdate,
        pictureUrl        : objectTemplate.pictureUrl,
        filePath          : objectTemplate.filePath,
        objectPic         : objectTemplate.objectPic,
        externalUrlByLanguage : objectTemplate.externalUrlByLanguage,
        isExternalUrlInNewWindow : objectTemplate.isExternalUrlInNewWindow,
        externalUrlLabel  : objectTemplate.externalUrlLabel
      }
      if(objectTemplate.externalUrl){
        data.externalUrl = objectTemplate.externalUrl;
      }
      let params = ['labels', 'description', 'pictureLastUpdate', 'externalUrlByLanguage', 'objectPic', 
                'externalUrl', 'isExternalUrlInNewWindow', 'externalUrlLabel', 'filePath']
      this.objectService.setObject(data).then(value => {
        result = value
        this.changeShowToast(value, n, 'Add')
        if(this.gamesChanges[i].changes.length == 1) this.gamesChanges.splice(i, 1)
        else this.gamesChanges[i].changes.splice(j, 1)
      }, err => {
        error = err
        console.log('error :',error)
        this.changeShowToast('error', n, 'Add')
      });
    }else{
      let data:any ={
        collectionPath: `games/${gameId}/objects`,
        //filePath: `games/${gameId}/objects/${objectTemplate.id}.jpg`,
        description       : objectTemplate.description,
        labels            : objectTemplate.labels,
        pictureLastUpdate : objectTemplate.pictureLastUpdate,
        pictureUrl        : objectTemplate.pictureUrl,
        filePath          : objectTemplate.filePath,
        objectPic         : objectTemplate.objectPic,
        externalUrlByLanguage : objectTemplate.externalUrlByLanguage,
        isExternalUrlInNewWindow : objectTemplate.isExternalUrlInNewWindow,
        externalUrlLabel  : objectTemplate.externalUrlLabel
      }
      if(objectTemplate.externalUrl){
        data.externalUrl = objectTemplate.externalUrl;
      }
      this.objectService.updateObject(objectGame, data).then(value => {
        result = value
        this.changeShowToast(value, n, 'Apply changes')
        if(this.gamesChanges[i].changes.length == 1) this.gamesChanges.splice(i, 1)
        else this.gamesChanges[i].changes.splice(j, 1)
      }, err => {
        error = err
        this.changeShowToast('error', n, 'Apply changes')
        console.log('error', error)
      });
    }
  }

  changeShowToast(type, n , action){
    if(n==0){
      if(type == 'error') this.showToast('Error', 'danger', `${action} object failed`, 'close-outline')
      else this.showToast('Success', 'success', `object successfully ${action}ed on game`, 'done-all-outline')
      
    }else if(n == this.gamesChanges.length){
      if(type == 'error') this.showToast('Error', 'danger', `${action} objects failed`, 'close-outline')
      else this.showToast('Success', 'success', `objects successfully ${action}ed on game`, 'done-all-outline')
    }
  }
  showToast(type,status ,text, iconName) {
    const icon: NbIconConfig = { icon: iconName, pack: 'eva' };
    let duration = 5000
    let position = this.positions.TOP_RIGHT
    this.toastrService.show(type , text, { position, status, duration,icon });
  }

  applyAllChanges(){
    this.dialogService.open(ConfirmModalComponent, { 
      context: {
        title: 'Confirmation',
        message: `Are you sure you want apply all changes?`
      }, closeOnBackdropClick: false
    })
    .onClose.subscribe(async res => {
      console.log('Dialog returns:'+res);
      if(res){
        for (let i = this.gamesChanges.length -1; i >= 0; i--) {
          const game = this.gamesChanges[i].changes;
          for (let j = game.length -1; j >= 0; j--) {
            const change = game[j];
            if( (this.gamesChanges.length - 1) == j && (game.length - 1) == j ){
              if(change.template?.id) await this.applyChanges(this.gamesChanges[i].gameId, change.template, change.objectGame, i, j, 0)
              else await this.deleteObject(change.objectGame, i ,j)
            } else{
              if(change.template?.id) await this.applyChanges(this.gamesChanges[i].gameId, change.template, change.objectGame, i, j, this.gamesChanges.length)
              else await this.deleteObject(change.objectGame, i ,j)
            }
          }
        }
      }
    });
  }

  toggleShowDetailGame(index) {
    this.gameVisibly[index] = this.gameVisibly[index]? !this.gameVisibly[index] : true;
  }
}